// removed by extract-text-webpack-plugin
module.exports = {"high_temperature":"high_temperature__1U93S","low_temperature":"low_temperature__2ZP5-","mean_temperature":"mean_temperature__1eriL","high_wind_gust":"high_wind_gust__3OBCA","rainfall":"rainfall__1QapN"};


//////////////////
// WEBPACK FOOTER
// ./components/highlight-values/style.scss
// module id = 3s4+
// module chunks = 13